/**
 * These content levels are intended to be used as a way to help coordinate the
 * various z-index values that are given to elements. For example, page layout
 * z-indexes are going to be low because page layout elements should generally
 * show behind everything else. Components go on pages, so should be higher up.
 * Navigation menus usually should display over any components so users can
 * actually use it. Modals are shown over as much as possible because we are
 * asking the user to focus on a task and we don't want to create any
 * distractions. Notifications are at the very front because they are real-time
 * messages that might take precedence over what the user is doing in the modal.
 *
 * Some examples of how to use:
 *
 * // If for some reason we need to specify a different z-index for some layout
 * // component, our levels make sure it's not just given a random z-index.
 * const MainPanel = styled.div`
 *   z-index: ${contentLevels.pages};
 * `
 *
 * // Maybe the callout should be just a bit higher to avoid some overlap.
 * // This is why we have 50 units between each level, to juggle things that
 * // are otherwise on the same content level.
 * const MainCallout = styled.div`
 *   z-index: ${contentLevels.pages+2};
 * `
 *
 * If some navigation menu shows up behind some dropdown, we can improve this
 * by adding z-indexes and making sure those things are in their proper content
 * level.
 * const UsefulNavMenu = styled.div`
 *   z-index: ${contentLevels.navigation};
 * `
 *
 * const Dropdown = styled.div`
 *   z-index: ${contentLevels.components};
 * `
 *
 * const FussyDropdown = styled.div`
 *   z-index: ${contentLevels.components + 1};
 * `
 *
 * Now the menu will show above the dropdown in all cases and the fussier
 * dropdown will display above the less fussy one.
 *
 * Admin drawers since they have some navigation components to them will
 * be at navigation level. While admin page components like the page level search
 * will be below it.
 *
 * const DrawerContainer = styled.div`
 *   z-index: ${contentLevels.navigation}
 * `
 */

export default {
  pages: 0,
  components: 10,
  navigation: 20,
  modals: 30,
  notifications: 40,
}
